import { MainPage } from '../pages/MainPage';
import { Studio } from '../pages/Studio';
import { Contact } from '../pages/Contact';
import { Found404 } from '../pages/Found404';
import { Switch, Route, useLocation } from 'react-router-dom';
import { AnimatePresence } from 'framer-motion';
import { Hamburger } from './Hamburger';

//Transition settings for the pages on page transition and load
const transition = { duration: 0.6, ease: [0.43, 0.13, 0.23, 0.96] };

export const Header = () => {
	const location = useLocation();

	return (
		<>
			{/* exitBeforeEnter prop allows components to dismantle and play their animations before new componenet loads. 
    All exit-props called on different motion-elements (e.g motion.div ) is used to make this possible in majority of components*/}

			<AnimatePresence exitBeforeEnter>
				{/* Navbar causes the framer-motion warning in console about animating multiple children, needs to be placed inside switch or outside the animateprescene.
        But any of those ways wont animate the navbar on exit.  */}
				<Hamburger page={location.pathname} />
				<Switch location={location} key={location.pathname}>
					<Route exact path="/" component={MainPage} transition={transition} />
					<Route exact path="/studio" component={Studio} transition={transition} />
					<Route exact path="/contact" component={Contact} transition={transition} />
					<Route component={Found404} transition={transition} />
				</Switch>
			</AnimatePresence>
		</>
	);
};
